<template lang="pug">
section
  div
    | Level 2 users can only be appointed
    | by a Level 1 user,
    | so you can only add a Level 2 user
    | after your licence has been granted.
    | Level 2 user has fewer permissions
    | than Level 1 user in SMS.

  br

  div
    | ✅
    |
    | The Level 2 user may be:

  ul
    li
      | a paid staff member or ‘office holder’
      | within your organisation;
    li
      | an employee of a third-party organisation
      | engaged by you to deliver all
      | or part of your HR function;
    li
      | a temporary staff member supplied to you
      | by an employment agency;
    li
      | a UK-based representative.

  br

  div
    | ⛔
    |
    | Level 2 user must not be:

  ul
    li
      | a contractor;
    li
      | a consultant who is contracted
      | for a specific project;
    li
      | an undischarged bankrupt.
</template>

<script>
export default {
  name: "key_personnel_level_2",
};
</script>